import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { SHOW_MESSAGE, SHOW_MESSAGE_SUCCESS, SHOW_MESSAGE_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* showMessage({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { messageId } = payload;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/tickets/messages/${messageId}/show`,
      method: 'PATCH',
      headers: { ...filteredHeaders },
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success('Message visibility updated');
      yield put({ type: SHOW_MESSAGE_SUCCESS, payload: response?.data });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({ type: SHOW_MESSAGE_ERROR, payload: response?.data?.message });
    }
  } catch (error) {
    yield put({ type: SHOW_MESSAGE_ERROR, payload: error });
  }
}

export function* watchShowMessage() {
  yield takeEvery(SHOW_MESSAGE, showMessage);
}

function* showMessageSaga() {
  yield all([fork(watchShowMessage)]);
}

export default showMessageSaga;
